/**
 * Location tabs interactivity
 *
 * Handles tab switching for the locations section.
 *
 * @package Interact_26
 */

export const initLocationTabs = (): void => {
  const tabs = document.querySelectorAll<HTMLButtonElement>('.careers-locations__tab');
  const panels = document.querySelectorAll<HTMLElement>('.careers-locations__panel');

  if (tabs.length === 0 || panels.length === 0) return;

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const locationKey = tab.dataset.location;
      if (!locationKey) return;

      // Deactivate all tabs
      tabs.forEach((t) => {
        t.classList.remove('careers-locations__tab--active');
        t.setAttribute('aria-selected', 'false');
      });

      // Fade out active panel, then switch
      const activePanel = document.querySelector<HTMLElement>('.careers-locations__panel--active');

      const showPanel = () => {
        // Hide all panels
        panels.forEach((p) => {
          p.classList.remove('careers-locations__panel--active');
          p.hidden = true;
        });

        // Show matching panel
        const panel = document.getElementById(`panel-${locationKey}`);
        if (panel) {
          panel.hidden = false;
          // Force reflow so the browser registers the opacity: 0 state before transitioning
          panel.offsetHeight;
          panel.classList.add('careers-locations__panel--active');
        }
      };

      // Activate clicked tab
      tab.classList.add('careers-locations__tab--active');
      tab.setAttribute('aria-selected', 'true');

      if (activePanel) {
        activePanel.classList.remove('careers-locations__panel--active');

        let handled = false;
        const onDone = () => {
          if (handled) return;
          handled = true;
          showPanel();
        };

        activePanel.addEventListener('transitionend', onDone, { once: true });
        // Fallback if transitionend never fires (e.g. no transition, reduced motion)
        setTimeout(onDone, 300);
      } else {
        showPanel();
      }
    });

    // Keyboard navigation
    tab.addEventListener('keydown', (e: KeyboardEvent) => {
      const tabsArray = [...tabs];
      const currentIdx = tabsArray.indexOf(tab);
      let newIndex = -1;

      if (e.key === 'ArrowRight') {
        newIndex = (currentIdx + 1) % tabsArray.length;
      } else if (e.key === 'ArrowLeft') {
        newIndex = (currentIdx - 1 + tabsArray.length) % tabsArray.length;
      } else if (e.key === 'Home') {
        newIndex = 0;
      } else if (e.key === 'End') {
        newIndex = tabsArray.length - 1;
      }

      if (newIndex >= 0) {
        e.preventDefault();
        tabsArray[newIndex].focus();
        tabsArray[newIndex].click();
      }
    });
  });
};
